import { Schema, OrSchema } from './get_schema.js';

const LocationTypes = [
  'accommodation',
  'campground',
  'campsite',
  'dayuse',
  'gate',
  'landform',
  'landing',
  'outfitter',
  'parking',
  'portage',
  'sight',
  'summercamp',
  'trailhead',
  'toponym',
  'wateraccess',
  'waterbody',
  'waterbody_feature',
];

const id = Schema.Int;
const description = Schema.String;
const google_id = Schema.String;
const lat = Schema.Float;
const lng = Schema.Float;
const routes = Schema.Default(
  Schema.Array(
    Schema.Array(
      Schema.Object({
        lat,
        lng,
        elevation: Schema.Float,
      })
    )
  ),
  []
);
const name = Schema.NotEmptyString;
const subtype = Schema.String;
const type = Schema.Enum(...LocationTypes);
const field = Schema.Array(Schema.String, Schema.String);
const fields = Schema.Default(Schema.Array(field), null);
const attributes = Schema.Default(
  Schema.Map(Schema.Array(Schema.String)),
  null
);
const cover = Schema.Or(Schema.String, null);
const pics = Schema.Default(Schema.Array(Schema.String), null);
const state = Schema.OptionalEnum('private', 'public', null);

const north = Schema.Float;
const south = Schema.Float;
const west = Schema.Float;
const east = Schema.Float;

const locId = id;
const loc = id;
const relatedId = id;
const relatedIds = Schema.Array(relatedId);

const availDate = Schema.Date;
const availData = Schema.AnyObject;

const locProperties = [
  'name',
  'description',
  'attributes',
  'fields',
  'type',
  'subtype',
  'google_id',
  'lat',
  'lng',
  'routes',
  'cover',
  'pics',
  'state',
];

const locSchemaFields = {
  id,
  name,
  description,
  attributes,
  fields,
  type,
  subtype,
  google_id,
  lat,
  lng,
  routes,
  cover,
  pics,

  relatedId,
  south,
  north,
  east,
  west,

  locId,
  relatedLocId: relatedId,

  availDate,
  availData,
};

const dpSchemaFields = {
  loc,
  type: Schema.NotEmptyString,
  provider: Schema.NotEmptyString,
  id: Schema.NotEmptyString,
};

const schema = {
  'add-location': new Schema({
    name,
    description,
    google_id,
    lat,
    lng,
    routes,
    type,
    subtype,
    fields,
    attributes,
    cover,
    pics,
    relatedIds: Schema.Optional(relatedIds),
    state,
  }),
  'associate': new Schema({
    id,
    relatedIds,
  }),
  'associate-with': new Schema({
    id,
    relatedId,
  }),
  'change-location': new Schema({
    id,
    name: Schema.Optional(name),
    description: Schema.Optional(description),
    google_id: Schema.Optional(google_id),
    lat: Schema.Optional(lat),
    lng: Schema.Optional(lng),
    routes: Schema.Optional(routes),
    type: Schema.Optional(type),
    subtype: Schema.Optional(subtype),
    fields: Schema.Optional(fields),
    attributes: Schema.Optional(attributes),
    cover: Schema.Optional(cover),
    pics: Schema.Optional(pics),
    relatedIds: Schema.Optional(relatedIds),
    state,
  }),
  'get-locations': new Schema({
    north: Schema.Optional(north),
    south: Schema.Optional(south),
    west: Schema.Optional(west),
    east: Schema.Optional(east),
  }),
  'get-locations-by-ids': new Schema({
    list: Schema.Array(id),
  }),
  'get-location-area': new Schema({
    id,
  }),
  'get-location-availability': new Schema({
    id,
  }),
  'get-location-details': new OrSchema(
    {
      id,
    },
    {
      provider: Schema.NotEmptyString,
      google_id: Schema.NotEmptyString,
    }
  ),
  'get-location-relations': new Schema({
    id,
  }),
  'get-location-history': new Schema({
    id,
  }),
  'find-by-criteria': new OrSchema(
    {
      fields: field,
    },
    {
      relatedId,
    }
  ),
  'find-by-dataprovider': new Schema({
    type: dpSchemaFields.type,
    provider: dpSchemaFields.provider,
    id: dpSchemaFields.id,
  }),
  'query-dataprovider': new Schema({
    loc,
    type: dpSchemaFields.type,
  }),
  'remove-location': new Schema({
    id,
  }),
  'search-locations': new Schema({
    name: Schema.StrictString,
    north: Schema.Optional(north),
    east: Schema.Optional(east),
    south: Schema.Optional(south),
    west: Schema.Optional(west),
    type: Schema.OptionalString,
    provider: Schema.OptionalString,
  }),
  'set-dataprovider': new Schema({
    loc,
    type: dpSchemaFields.type,
    provider: dpSchemaFields.provider,
    id: dpSchemaFields.id,
  }),
};

export {
  schema as LocationSchema,
  locSchemaFields as LocationSchemaFields,
  dpSchemaFields as DataProviderSchemaFields,
  locProperties as LocationProperties,
  LocationTypes,
};
